import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a08276df6558f0014a83cf1/tankside_1778919277271/src/app/about/page.tsx");
